// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_mech1_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Yields under each step like a forest floor. Shock is absorbed before it reaches your joints and spine.`
};

const el_tech_mech1_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Υποχωρεί κάτω από κάθε βήμα σαν δασικό έδαφος. Οι κραδασμοί απορροφώνται πριν φτάσουν στις αρθρώσεις και τη σπονδυλική στήλη.`
};

const ru_tech_mech1_desc = /** @type {(inputs: {}) => string} */ () => {
	return `Пружинит под каждым шагом как лесная почва. Удар поглощается до того, как достигнет суставов и позвоночника.`
};

const he_tech_mech1_desc = /** @type {(inputs: {}) => string} */ () => {
	return `נענית תחת כל צעד כמו קרקעית יער. הזעזוע נספג לפני שמגיע למפרקים ולעמוד השדרה.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_mech1_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_mech1_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_mech1_desc", locale)
	if (locale === "en") return en_tech_mech1_desc(inputs)
	if (locale === "el") return el_tech_mech1_desc(inputs)
	if (locale === "ru") return ru_tech_mech1_desc(inputs)
	if (locale === "he") return he_tech_mech1_desc(inputs)
	return "tech_mech1_desc"
};